import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wfdss-link-configuration-component',
    templateUrl: './link-configuration-component.component.html',
    styleUrls: ['./link-configuration-component.component.scss'],
    standalone: false
})
export class LinkConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
